import { getProprietorsList } from '@/api/proprietors.js'
import { getDesignList } from '@/api/designs.js'
import { getUserList } from '@/api/markets.js'
import { getDictInfoByCode } from '@/api/dict'
const market = {
  state: {
    proprietorId: {}, // 业主id
    marketModel: {}, // 市场实体
    userList: [], // 人员列表
    statusList: [], // 状态列表
    proprietorList: [], // 业主列表
    designList: [] // 设计代表列表
  },
  getters: {
    // goodsTypeList: state => state.goodsTypeList,
    // receiveSendTypeList: state => state.receiveSendTypeList,
    // suppliesTypeList: state => state.suppliesTypeList,
  },
  mutations: {
    proprietorId: (state, proprietorId) => {
      state.proprietorId = proprietorId
    },
    marketModel: (state, marketModel) => {
      state.marketModel = marketModel
    },
    statusList: (state, statusList) => {
      state.statusList = statusList
    },
    userList: (state, userList) => {
      state.userList = userList
    },
    proprietorList: (state, proprietorList) => {
      state.proprietorList = proprietorList
    },
    designList: (state, designList) => {
      state.designList = designList
    }
  },
  actions: {
    handleStatusList (statusList, data) {
      getDictInfoByCode({ pCode: 'MARKET_STATUS' }).then(res => {
        if (res.status === 0) {
          statusList.commit('statusList', res.data)
        }
      })
    },
    handleUserList (userList, data) {
      getUserList({ paging: false }).then(res => {
        if (res.status === 0) {
          userList.commit('userList', res.data)
        }
      })
    },
    handleProprietorList (proprietorList, data) {
      getProprietorsList({ paging: false }).then(res => {
        if (res.status === 0) {
          proprietorList.commit('proprietorList', res.data)
        }
      })
    },
    handleDesignList (designList, data) {
      getDesignList({ paging: false }).then(res => {
        if (res.status === 0) {
          designList.commit('designList', res.data)
        }
      })
    }
  }
}

export default market
